import React from "react";

import { Radio, FormControlLabel, Box } from "@mui/material";

import "./radiobutton.scss";

function RadioButton({ label, checked, onChange, value, name, withContainer = false, disabled = false }) {
  const radioControl = (
    <FormControlLabel
      control={<Radio disabled={disabled} checked={checked} onChange={onChange} value={value} name={name} />}
      label={
        <div className={`para-body-m-medium ${disabled ? "color-text-body-disabled" : "color-text-body-secondary"}`}>
          {label}
        </div>
      }
      className={`radio-button__control ${disabled ? "radio-button__control-disabled" : ""}`}
    />
  );

  const handleContainerClick = () => {
    if (!checked && !disabled) {
      onChange({ target: { value, name } });
    }
  };

  return withContainer ? (
    <Box
      onClick={handleContainerClick}
      className={`radio-button__container ${checked ? "radio-button__container-checked" : ""} ${
        disabled ? "radio-button__container-disabled" : ""
      }`}
    >
      {radioControl}
    </Box>
  ) : (
    <Box className="radio-button__wrapper">{radioControl}</Box>
  );
}

export default RadioButton;
